const image = (() => {
    const initBlock = img => {
        const windowHeight = window.innerHeight;
        if (img.getBoundingClientRect().top <= windowHeight) {
            img.setAttribute('loading', 'eager');
        }
    };
    return {initBlock};
})();
document.querySelectorAll('img[loading="lazy"]').forEach(el => image.initBlock(el));